export const SSO = 'sso';
export const PASSWORD = 'password';
